<script>
    export default {
        methods: {
            isSet() {
                return Cookies.get('cookie_consent');
            },
            set() {
                if (this.isSet()) {
                    this.remove();
                } else {
                    this.add();
                }
                location.reload(true);
            },
            remove() {
                Cookies.remove('cookie_consent');
            },
            add() {
                Cookies.set('cookie_consent', Date.now());
            },
        },
    };
</script>
